import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideBarComponent } from './side-bar/side-bar.component';
import { FormComponent } from './form/form.component';
import { SelectDependsComponent } from './select-depends/select-depends.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { PopupComponent } from './popup/popup.component';
import { HeaderComponent } from './header/header.component';
import { TableComponent } from './table/table.component';
import { ProgresBarComponent } from './progres-bar/progres-bar.component';
import { QuillModule } from 'ngx-quill'


@NgModule({
  declarations: [
    SideBarComponent,
    FormComponent,
    SelectDependsComponent,
    DatePickerComponent,
    PopupComponent,
    HeaderComponent,
    TableComponent,
    ProgresBarComponent,
    

  ],
  imports: [
    CommonModule,
    NgSelectModule,
    NgbDatepickerModule,
     FormsModule,
     QuillModule.forRoot(),

  ],
  exports:[
    SideBarComponent,
    ProgresBarComponent,
    FormComponent,
    SelectDependsComponent,
    PopupComponent,
    HeaderComponent,
    DatePickerComponent,
    TableComponent
    
  ],
  entryComponents:[
    HeaderComponent
  ]
})
export class SharedModule { }
